import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import {
  BufferService,
  LoadingContext,
  NavigateContext,
  M_Button,
  M_Header,
  M_MessageBoard,
} from "src/M_Components";
import { Check } from "@mui/icons-material";
import { ServiceTypeDetails } from "./components/ServiceTypeDetails";
import { ServiceTypeDefaultValues } from "./components/ServiceTypeDefaultValues";

export const ServiceTypeDetail = ({ roles }) => {
  const [id, setId] = useState(sessionStorage.getItem("selectedTab"));
  const { t } = useTranslation();
  const ctx = useContext(LoadingContext);
  const navigateCtx = useContext(NavigateContext)
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [passedRow, setPassedRow] = useState({});
  const [operation, setOperation] = useState("");
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [showPageCloseModal, setShowPageCloseModal] = useState(false);

  const serviceTypeService = new BufferService("ServiceType");

  const sessionKeys = ["operation", "data", "open", "passedRow"];

  const matches11 = useMediaQuery("(min-width:970px)");

  useEffect(() => {
    if (isFirstTime) {
      ctx.setIsLoad(true);
      getSessionStorageData(id);
      setIsFirstTime(false);
      sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys));
    }
  }, []);

  useEffect(() => {
    const passOperation = ctx.passValue.get("operation");
    setOperation(passOperation);
  }, []);

  useEffect(() => {
    const newId = sessionStorage.getItem("selectedTab");
    if (newId !== id) {
      setId(newId);
      getSessionStorageData(newId);
    }
  }, []);

  useEffect(() => {
    sessionKeys.forEach((key) => {
      sessionStorageMachine(id, key, key);
    });
    // eslint-disable-next-line
  }, [id, operation, data]);

  const sessionStorageMachine = (id, key, value) => {
    if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0)
      return;
    if (eval(value) instanceof String && eval(value) === "") return;
    if (eval(value) instanceof Number && eval(value) === "") return;

    // eslint-disable-next-line
    if (eval(value) instanceof Map) {
      // eslint-disable-next-line
      sessionStorage.setItem(
        `${id}${key}`,
        JSON.stringify(Array.from(eval(value))),
      );
    } else {
      // eslint-disable-next-line
      sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)));
    }
  };

  const getSessionStorageData = (sessionID) => {
    ctx.setIsLoad(true);
    const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`));
    const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`));
    const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`));
    const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`));

    if (
      (tempO && tempO !== "") ||
      (tempD && Object.keys(tempD).length !== 0) ||
      tempOS ||
      (tempPR && Object.keys(tempD).length !== 0)
    ) {
      setOperation(new String(tempO));
      setData(new Object(tempD));
      setOpen(tempOS);
      setPassedRow(tempPR);
      ctx.setIsLoad(false);

      return;
    }
    get();
  };

  const functionLeavingPage = () => {
    navigateCtx.closeTab(JSON.parse(id))
  }

  const get = () => {
    const row = ctx.passValue.get("Row")
    const rows = ctx.passValue.get("Rows")

    if (ctx.passValue.get("operation") === "edit" && row && (!rows || rows.length === 1)) {
      const lines = ctx.passValue.get('Row')
      const tempId = lines.Id
      serviceTypeService.getId(tempId).then((response) => {
        if (response.name === "AxiosError") {
          ctx.toastMessages(
            "error",
            t("Error"),
            response?.response?.data?.Errors || response.message,
          );
          ctx.setIsLoad(false);
          return;
        }

        setData(response);

        ctx.setIsLoad(false);
      })
        .catch((err) => {
          ctx.toastMessages("error", err.message, "Error");
          ctx.setIsLoad(false);
        });
    }

    ctx.setIsLoad(false);
  };

  const onSave = () => {
    ctx.setIsLoad(true);

    if (operation === "create") {
      serviceTypeService.post(data).then((response) => {
        if (response.name === "AxiosError") {
          const data = response?.response?.data

          ctx.toastMessages(
            "error",
            t("ErrorCreating"),
            data !== null && data !== undefined ? Object.values(data).flat().join("\n") || response.message : "",
          );
          ctx.setIsLoad(false);
        } else {
          ctx.toastMessages(
            "success",
            t("Success"),
            t("CreatedServiceType"),
          );
          ctx.setIsLoad(false);

          navigateCtx.closeTab(id.replace(/"/g, ''))
        }
      });
    } else if (operation === "edit") {
      serviceTypeService.update(data.Id, data).then((response) => {
        if (response.name === "AxiosError") {
          const data = response?.response?.data

          ctx.toastMessages(
            "error",
            t("ErrorUpdating"),
            data !== null && data !== undefined ? Object.values(data).flat().join("\n") || response.message : "",
          );
          ctx.setIsLoad(false);
        } else {
          ctx.toastMessages(
            "success",
            t("Success"),
            t("EditedServiceType"),
          );
          ctx.setIsLoad(false);

          navigateCtx.closeTab(id.replace(/"/g, ''))
        }
      });
    }
  };

  return (
    <div>
      <M_Header
        element={
          <>
            <M_Button
              tooltip={t("Back")}
              label={t("Back")}
              icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
              onClick={() => { setShowPageCloseModal(true) }}
            />
            <M_Button
              tooltip={t("Save")}
              icon={<i className="pi pi-save iconTable"></i>}
              label={t("Save")}
              onClick={() => onSave()}
            />
          </>
        }
      />
      <div style={{ margin: "20px" }}>
        <div>
          <ServiceTypeDetails dataState={data} setDataState={setData} />
          <ServiceTypeDefaultValues dataState={data} setDataState={setData} />
        </div>
      </div>
      <M_MessageBoard
        warning
        open={showPageCloseModal}
        onClose={() => setShowPageCloseModal(false)}
        title={t("leavingPageTitle")}
        body={t("leavingPageBody")}
        footer={
            <span style={{ display: 'flex', alignItems: 'center' }}>
                <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setShowPageCloseModal(false)} label={t("ButtonCancel")} />
                <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={functionLeavingPage} label={t("ButtonConfirm")} />
            </span>
        }
      />
    </div>
  );
};
